/* eslint-disable no-shadow */
import React from "react"

import { Formik, Form } from "formik"

import { logTool } from "@jsUtils"

const log = logTool()

/**
 * FormWrapper - wrapper around Formik forms
 * @param {object} props - react props
 * @param {string} props.className - optional CSS classes to add to <form> element
 * @param {object} props.initVals - initial values for Formik form
 * @param {object} props.validation - validation schema for Yup
 * @param {function} props.status - function to respond to various conditions
 * @param {object} props.submit - onSubmit handler for Formik
 */
const FormWrapper = props => {
  const { children, className, initVals, validation, submit, status } = props
  // console.log("initVals", initVals)
  return (
    <Formik initialValues={initVals} validationSchema={validation} onSubmit={submit}>
      {props => {
        const { errors, submitCount } = props
        if (status) {
          status(submitCount, errors)
        }
        return <Form className={className}>{children}</Form>
      }}
    </Formik>
  )
}

export default FormWrapper
